let TextList: any = [{
	id: 1,
	cn: "请输入账号",
	tc: "請輸入帳號",
	en: "Please Enter Account",
}, {
	id: 2,
	cn: "请输入密码",
	tc: "請輸入密碼",
	en: "Please Enter Password",
}, {
	id: 3,
	cn: "记住密码",
	tc: "記住密碼",
	en: "Remember Password",
}, {
	id: 4,
	cn: "登录中...",
	tc: "登入中...",
	en: "Log In...",
}, {
	id: 5,
	cn: "登录",
	tc: "登入",
	en: "Log In",
}, {
	id: 6,
	cn: "RFID智能盘点系统",
	tc: "RFID智慧數據管理系統",
	en: "RFID Intelligent Inventory System",
}, {
	id: 7,
	cn: "个人信息",
	tc: "個人資訊",
	en: "Personal Information",
}, {
	id: 8,
	cn: "退出登录",
	tc: "退出登錄",
	en: "Log Out",
}, {
	id: 9,
	cn: "累计入库商品数",
	tc: "累計入庫商品數",
	en: "Total Number of Goods Inbound",
}, {
	id: 10,
	cn: "累计出库商品数",
	tc: "累計出庫商品數",
	en: "Total Number of Goods Outbound",
}, {
	id: 11,
	cn: "仓库使用率",
	tc: "倉庫使用率",
	en: "Warehouse Utilization Rate",
}, {
	id: 12,
	cn: "货位空闲",
	tc: "貨位空閑",
	en: "Storage Unit Free",
}, {
	id: 13,
	cn: "货位占用",
	tc: "貨位佔用",
	en: "Storage Unit Occupied"
}, {
	id: 14,
	cn: "系统配置",
	tc: "系統配置",
	en: "System Configuration",
}, {
	id: 15,
	cn: "区域类型名称",
	tc: "區域類型名稱",
	en: "Region Type Name",
}, {
	id: 16,
	cn: "过期",
	tc: "過期",
	en: "Expiration",
}, {
	id: 17,
	cn: "所属企业",
	tc: "所屬企業",
	en: "Affiliated Company",
}, {
	id: 18,
	cn: "员工数量",
	tc: "員工數量",
	en: "Number of Employees",
}, {
	id: 19,
	cn: "仓库数据统计",
	tc: "倉庫數據統計",
	en: "Warehouse Statistics",
}, {
	id: 20,
	cn: "入库数据",
	tc: "入庫數據",
	en: "Inbound Data",
}, {
	id: 21,
	cn: "出库数据",
	tc: "出庫數據",
	en: "Outbound Data",
}, {
	id: 23,
	cn: "订单平均耗时",
	tc: "訂單平均耗時",
	en: "Average Order Time",
}, {
	id: 24,
	cn: "今日",
	tc: "今日",
	en: "Today",
}, {
	id: 25,
	cn: "本周",
	tc: "本週",
	en: "This Week",
}, {
	id: 26,
	cn: "本月",
	tc: "本月",
	en: "This Month",
}, {
	id: 27,
	cn: "预警信息",
	tc: "預警信息",
	en: "Warning information",
}, {
	id: 28,
	cn: "托盘编号",
	tc: "託盤編號",
	en: "Storage Unit Code",
}, {
	id: 29,
	cn: "托盘名称",
	tc: "託盤名稱",
	en: "Storage Unit Name",
}, {
	id: 30,
	cn: "托盘形状",
	tc: "託盤形狀",
	en: "Storage Unit Shape",
}, {
	id: 31,
	cn: "托盘材质",
	tc: "託盤材質",
	en: "Storage Unit Material",
}, {
	id: 32,
	cn: "快速上手",
	tc: "快速上手",
	en: "Getting Started Quickly",
}, {
	id: 33,
	cn: "STEP1 基础数据管理",
	tc: "STEP1 基礎數據管理",
	en: "STEP1 Basic Data Management",
}, {
	id: 34,
	cn: "STEP2 角色与权限分配",
	tc: "STEP2 角色與權限分配",
	en: "STEP2 Role and Privileges Allocation",
}, {
	id: 35,
	cn: "STEP3 仓库作业及硬件配置",
	tc: "STEP3 倉庫作業及硬件配置",
	en: "STEP3 Operation & Hardware Configuration",
}, {
	id: 36,
	cn: "STEP4 报表管理",
	tc: "STEP4 報表管理",
	en: "STEP4 Statement Management",
}, {
	id: 37,
	cn: "搜索",
	tc: "搜索",
	en: "Search",
}, {
	id: 38,
	cn: "清空",
	tc: "清空",
	en: "Empty",
}, {
	id: 39,
	cn: "上传文件以导入托盘类型",
	tc: "上傳文件以導入託盤類型",
	en: "Upload a file to import the storage unit type"
}, {
	id: 40,
	cn: "托盘类型导入模板",
	tc: "託盤類型導入模板",
	en: "Storage Unit Type Import Template"
}, {
	id: 41,
	cn: "添加",
	tc: "添加",
	en: "Add",
}, {
	id: 42,
	cn: "请选择托盘类型",
	tc: "請選擇託盤類型",
	en: "Please select the storage unit type",
}, {
	id: 43,
	cn: "请输入名称",
	tc: "請輸入名稱",
	en: "Please enter the name",
}, {
	id: 44,
	cn: "请选择形状",
	tc: "請選擇形狀",
	en: "Please select the shape",
}, {
	id: 45,
	cn: "请选择材质",
	tc: "請選擇材質",
	en: "Please select the material",
}, {
	id: 46,
	cn: "下载导入模板",
	tc: "下載導入模板",
	en: "Download the import template",
}, {
	id: 47,
	cn: "确定",
	tc: "確定",
	en: "OK",
}, {
	id: 48,
	cn: "文件上传中...",
	tc: "文件上傳中...",
	en: "File Uploading..."
}, {
	id: 49,
	cn: "点击或将文件拖拽到这里上传",
	tc: "點擊或將文件拖拽到這裡上傳",
	en: "Click or drag the file here to upload",
}, {
	id: 50,
	cn: "删除",
	tc: "刪除",
	en: "Delete",
}, {
	id: 51,
	cn: "编号",
	tc: "編號",
	en: "Number",
}, {
	id: 52,
	cn: "名称",
	tc: "名稱",
	en: "Name",
}, {
	id: 53,
	cn: "尺寸",
	tc: "尺寸",
	en: "Size",
}, {
	id: 54,
	cn: "形状",
	tc: "形狀",
	en: "Shape",
}, {
	id: 55,
	cn: "材质",
	tc: "材质",
	en: "Material",
}, {
	id: 56,
	cn: "状态",
	tc: "狀態",
	en: "Status",
}, {
	id: 57,
	cn: "操作",
	tc: "操作",
	en: "Operation",
}, {
	id: 58,
	cn: "编辑",
	tc: "編輯",
	en: "Edit",
}, {
	id: 59,
	cn: "导出",
	tc: "導出",
	en: "Export",
}, {
	id: 60,
	cn: "导入",
	tc: "導入",
	en: "Import",
}, {
	id: 61,
	cn: "入库类型配置",
	tc: "入庫類型配置",
	en: "Inbound Type Configuration",
}, {
	id: 62,
	cn: "出库类型配置",
	tc: "出庫類型配置",
	en: "Outbound Type Configuration",
}, {
	id: 63,
	cn: "货位类型配置",
	tc: "貨位類型配置",
	en: "Storage Unit Type Configuration",
}, {
	id: 64,
	cn: "区域类型配置",
	tc: "區域類型配置",
	en: "Region Type Configuration",
}, {
	id: 65,
	cn: "仓库名称不能为空",
	tc: "倉庫名稱不能為空",
	en: "Warehouse Name cannot be empty"
}, {
	id: 66,
	cn: "编辑入库类型",
	tc: "編輯入庫類型",
	en: "Edit Inbound Type"
}, {
	id: 67,
	cn: "添加入库类型",
	tc: "添加入庫類型",
	en: "Add Inbound Type"
}, {
	id: 68,
	cn: "编辑出库类型",
	tc: "編輯出庫類型",
	en: "Edit Outbound Type"
}, {
	id: 69,
	cn: "添加出库类型",
	tc: "添加出庫類型",
	en: "Add Outbound Type"
}, {
	id: 70,
	cn: "编辑区域类型",
	tc: "編輯區域類型",
	en: "Edit Region Type"
}, {
	id: 71,
	cn: "添加区域类型",
	tc: "添加區域類型",
	en: "Add Region Type"
}, {
	id: 72,
	cn: "编辑货位类型",
	tc: "編輯貨位類型",
	en: "Edit Storage Unit Type"
}, {
	id: 73,
	cn: "添加货位类型",
	tc: "添加貨位類型",
	en: "Add Storage Unit Type"
}, {
	id: 74,
	cn: "取消",
	tc: "取消",
	en: "Cancel",
}, {
	id: 75,
	cn: "保存中",
	tc: "保存中",
	en: "Save",
}, {
	id: 76,
	cn: "保存",
	tc: "保存",
	en: "Save",
}, {
	id: 77,
	cn: "类型编码",
	tc: "類型編碼",
	en: "Type Code",
}, {
	id: 78,
	cn: "编辑托盘类型",
	tc: "編輯託盤類型",
	en: "Edit Storage Unit Type"
}, {
	id: 79,
	cn: "添加托盘类型",
	tc: "添加託盤類型",
	en: "Add Storage Unit Type"
}, {
	id: 85,
	cn: "请选择托盘材质",
	tc: "請選擇託盤材質",
	en: "Please select the storage unit material",
}, {
	id: 86,
	cn: "请选择状态",
	tc: "請選擇狀態",
	en: "Please select the status",
}, {
	id: 87,
	cn: "请输入长",
	tc: "請輸入長",
	en: "Please enter the length",
}, {
	id: 88,
	cn: "请输入宽",
	tc: "請輸入寬",
	en: "Please enter the width",
}, {
	id: 89,
	cn: "请输入高",
	tc: "請輸入高",
	en: "Please enter the height",
}, {
	id: 90,
	cn: "仓库编码",
	tc: "倉庫編碼",
	en: "Warehouse Code",
}, {
	id: 91,
	cn: "仓库名称",
	tc: "倉庫名稱",
	en: "Warehouse Name",
}, {
	id: 92,
	cn: "仓库管理",
	tc: "倉庫管理",
	en: "Warehouse Management",
}, {
	id: 93,
	cn: "请输入",
	tc: "請輸入",
	en: "Please Enter",
}, {
	id: 94,
	cn: "备注",
	tc: "備註",
	en: "Remarks",
}, {
	id: 95,
	cn: "区域设置",
	tc: "區域設定",
	en: "Region Setting",
}, {
	id: 96,
	cn: "巷道设置",
	tc: "巷道設置",
	en: "Laneway Setting",
}, {
	id: 97,
	cn: "货柜设置",
	tc: "貨柜設置",
	en: "Shelf Setting",
}, {
	id: 98,
	cn: "货位设置",
	tc: "貨位設置",
	en: "Storage Unit Setting",
}, {
	id: 99,
	cn: "查看区域货位",
	tc: "查看區域貨位",
	en: "View Region Storage Unit",
}, {
	id: 100,
	cn: "托盘设置",
	tc: "託盤设置",
	en: "Set Storage Unit",
}, {
	id: 101,
	cn: "模板下载",
	tc: "模板下載",
	en: "Download Excel template",
}, {
	id: 102,
	cn: "启用",
	tc: "啟用",
	en: "Enable"
}, {
	id: 103,
	cn: "区域名称",
	tc: "區域名稱",
	en: "Region Name",
}, {
	id: 104,
	cn: "刷新",
	tc: "刷新",
	en: "Refresh",
}, {
	id: 106,
	cn: "所属仓库",
	tc: "所屬倉庫",
	en: "Affiliated Warehouse",
}, {
	id: 107,
	cn: "请选择仓库",
	tc: "請選擇倉庫",
	en: "Please select the warehouse",
}, {
	id: 108,
	cn: "系统自动生成",
	tc: "系統自動生成",
	en: "Automatically generated by th system",
}, {
	id: 109,
	cn: "请输入区域名称",
	tc: "請輸入區域名稱",
	en: "Please enter the region name",
}, {
	id: 110,
	cn: "区域类型",
	tc: "區域類型",
	en: "Region Type",
}, {
	id: 111,
	cn: "请选择区域类型",
	tc: "請選擇區域類型",
	en: "Please select the region type",
}, {
	id: 112,
	cn: "请输入仓容定额",
	tc: "請輸入倉容定額",
	en: "Please enter the storage capacity quota",
}, {
	id: 113,
	cn: "打印货位编号",
	tc: "列印貨位編號",
	en: "Print Storage Unit Code"
}, {
	id: 114,
	cn: "区域",
	tc: "區域",
	en: "Region",
}, {
	id: 115,
	cn: "所属区域",
	tc: "所屬區域",
	en: "Affiliated Region",
}, {
	id: 116,
	cn: "该数据已关联其他数据，删除该数据后将删除下面关联的所有数据，是否确认并继续？",
	tc: "該數據已關聯其他數據，删除該數加载中據後將删除下麵關聯的所有數據，是否確認並繼續？",
	en: "This data has been affiliated with other data, deletion of this data will cause affiliated data lost, still want to confirm and continue?",
}, {
	id: 117,
	cn: "请选择巷道",
	tc: "請選擇巷道",
	en: "Please select the laneway",
}, {
	id: 118,
	cn: "加载中...",
	tc: "加載中...",
	en: "Loading...",
}, {
	id: 119,
	cn: "请选择区域",
	tc: "請選擇區域",
	en: "Please select the region",
}, {
	id: 120,
	cn: "行数",
	tc: "行數",
	en: "Number of Rows",
}, {
	id: 121,
	cn: "列数",
	tc: "列數",
	en: "Number of Columns",
}, {
	id: 122,
	cn: "创建货位",
	tc: "創建貨位",
	en: "Create Storage Unit"
}, {
	id: 123,
	cn: "请选择货柜",
	tc: "請選擇貨柜",
	en: "Please select the shelf",
}, {
	id: 124,
	cn: "巷道编码",
	tc: "巷道編碼",
	en: "Laneway Code",
}, {
	id: 125,
	cn: "巷道名称",
	tc: "巷道名稱",
	en: "Laneway Name",
}, {
	id: 126,
	cn: "请输入巷道名称",
	tc: "請輸入巷道名稱",
	en: "Please enter the laneway name",
}, {
	id: 127,
	cn: "请选择所属仓库",
	tc: "請選擇所屬倉庫",
	en: "Please select the affilated warehouse",
}, {
	id: 128,
	cn: "货柜编码",
	tc: "貨柜編碼",
	en: "Shelf Code",
}, {
	id: 129,
	cn: "请选择所属区域",
	tc: "請選擇所屬區域",
	en: "Please select the affilated region"
}, {
	id: 130,
	cn: "所属巷道",
	tc: "所属巷道",
	en: "Affiliated Laneway",
}, {
	id: 131,
	cn: "请选择所属巷道",
	tc: "請選擇所屬巷道",
	en: "Please select the affilated laneway",
}, {
	id: 132,
	cn: "货柜名称",
	tc: "貨柜名稱",
	en: "Shelf Name",
}, {
	id: 133,
	cn: "请输入货柜名称",
	tc: "請輸入貨柜名稱",
	en: "Please enter the shelf name",
}, {
	id: 134,
	cn: "请输入行数",
	tc: "請輸入行數",
	en: "Please enter the number of rows",
}, {
	id: 135,
	cn: "请输入列数",
	tc: "請輸入列數",
	en: "Please enter the number of columns",
}, {
	id: 136,
	cn: "仓库货位货位列表",
	tc: "倉庫貨位貨位列表",
	en: "Warehouse Storage Unit List"
}, {
	id: 137,
	cn: "货柜",
	tc: "貨柜",
	en: "Shelf",
}, {
	id: 138,
	cn: "所属区域编码",
	tc: "所屬區域編碼",
	en: "Affiliated Region Code",
}, {
	id: 139,
	cn: "所属货柜编码",
	tc: "所屬貨柜編碼",
	en: "Affiliated Shelf Code",
}, {
	id: 140,
	cn: "货位编码",
	tc: "貨位編碼",
	en: "Storage Unit Code"
}, {
	id: 141,
	cn: "当前货位",
	tc: "當前貨位",
	en: "Current Storage Unit"
}, {
	id: 142,
	cn: "所属货柜",
	tc: "所屬貨柜",
	en: "Affiliated Shelf",
}, {
	id: 143,
	cn: "请选择所属货柜",
	tc: "請選擇所屬貨柜",
	en: "Please select the affiliated shelf",
}, {
	id: 144,
	cn: "货位类型",
	tc: "貨位類型",
	en: "Storage Unit Type"
}, {
	id: 145,
	cn: "请选择货位类型",
	tc: "請選擇貨位類型",
	en: "Please select the storage unit type"
}, {
	id: 150,
	cn: "最大重量",
	tc: "最大重量",
	en: "Maximum Weight",
}, {
	id: 151,
	cn: "请输入最大重量",
	tc: "請輸入最大重量",
	en: "Please enter the maximum weight",
}, {
	id: 152,
	cn: "区域管理",
	tc: "區域管理",
	en: "Region Management"
}, {
	id: 154,
	cn: "禁用",
	tc: "禁用",
	en: "Disable"
}, {
	id: 155,
	cn: "所属仓库编码",
	tc: "所屬倉庫編碼",
	en: "Affiliated Warehouse Code",
}, {
	id: 156,
	cn: "所属仓库名称",
	tc: "所屬倉庫名稱",
	en: "Affiliated Warehouse Name",
}, {
	id: 157,
	cn: "请选择文件",
	tc: "請選擇文件",
	en: "Please select the file"
}, {
	id: 158,
	cn: "货位管理",
	tc: "貨位管理",
	en: "Storage Unit Management"
}, {
	id: 161,
	cn: "所属区域名称",
	tc: "所屬區域名稱",
	en: "Affiliated Region Name",
}, {
	id: 162,
	cn: "所属货柜编号",
	tc: "所屬貨柜編號",
	en: "Affiliated Shelf Number",
}, {
	id: 163,
	cn: "请选择货位",
	tc: "請選擇貨位",
	en: "Please select the storage unit"
}, {
	id: 164,
	cn: "客户名称",
	tc: "客戶名稱",
	en: "Customers Name",
}, {
	id: 165,
	cn: "客户管理",
	tc: "客戶管理",
	en: "Customers Management",
}, {
	id: 166,
	cn: "手机号",
	tc: "手機號",
	en: "Cell Phone No.",
}, {
	id: 167,
	cn: "客户编号",
	tc: "客戶編號",
	en: "Customers No.",
}, {
	id: 169,
	cn: "所属公司",
	tc: "所屬公司",
	en: "Affiliated Company",
}, {
	id: 170,
	cn: "固定电话",
	tc: "固定電話",
	en: "Landline Phone No.",
}, {
	id: 171,
	cn: "邮箱",
	tc: "郵箱",
	en: "E-mail",
}, {
	id: 172,
	cn: "请选择客户",
	tc: "請選擇客戶",
	en: "Please select the customer(s)",
}, {
	id: 173,
	cn: "请输入邮箱",
	tc: "請輸入郵箱",
	en: "Please enter e-mail address",
}, {
	id: 174,
	cn: "地区",
	tc: "地區",
	en: "Region",
}, {
	id: 175,
	cn: "请选择地区",
	tc: "請選擇地區",
	en: "Please select the region",
}, {
	id: 176,
	cn: "请输入所属公司",
	tc: "請輸入所屬公司",
	en: "Please enter the company belonged",
}, {
	id: 177,
	cn: "详细地址",
	tc: "詳細地址",
	en: "Full Address",
}, {
	id: 178,
	cn: "请输入详细地址",
	tc: "請輸入詳細地址",
	en: "Please enter your full address",
}, {
	id: 179,
	cn: "请输入手机号",
	tc: "請輸入手機號",
	en: "Please enter your cell phone no.",
}, {
	id: 180,
	cn: "请输入固定电话",
	tc: "請輸入固定電話",
	en: "Please enter your landline phone no.",
}, {
	id: 181,
	cn: "生成溯源码",
	tc: "生成溯源碼",
	en: "Generate Traceability Code",
}, {
	id: 182,
	cn: "手机号长度不能小于11位",
	tc: "手機號長度不能小於11位",
	en: "The length of the cell phone no. cannot be less than 11 digits",
}, {
	id: 183,
	cn: "手机号长度不能大于11位",
	tc: "手機號長度不能大於11位",
	en: "The length of the mobile phone no. cannot exceed 11 digits",
}, {
	id: 184,
	cn: "溯源码详情",
	tc: "溯源碼詳情",
	en: "Traceability Code Details",
}, {
	id: 185,
	cn: "商品分类",
	tc: "商品分類",
	en: "Product Category",
}, {
	id: 186,
	cn: "主分类列表",
	tc: "主分類列表",
	en: "Main Category List",
}, {
	id: 187,
	cn: "添加主分类",
	tc: "添加主分類",
	en: "Add Main Category",
}, {
	id: 188,
	cn: "添加二级分类",
	tc: "添加二級分類",
	en: "Add Secondary Level Category",
}, {
	id: 189,
	cn: "修改主分类",
	tc: "修改主分類",
	en: "Modify Main Category",
}, {
	id: 190,
	cn: "请输入主分类名称",
	tc: "請輸入主分類名稱",
	en: "Please enter the main category name",
}, {
	id: 191,
	cn: "请输入二级分类",
	tc: "請輸入二級分類",
	en: "Please enter the secondary level category",
}, {
	id: 192,
	cn: "请选择分类",
	tc: "請選擇分類",
	en: "Please select a category",
}, {
	id: 193,
	cn: "请输入分类名称",
	tc: "請輸入分類名稱",
	en: "Please enter the category name",
}, {
	id: 194,
	cn: "分类名称",
	tc: "分類名稱",
	en: "Category Name",
}, {
	id: 195,
	cn: "添加三级分类",
	tc: "添加三級分類",
	en: "Add Third Level Category",
}, {
	id: 196,
	cn: "请输入三级分类",
	tc: "請輸入三級分類",
	en: "Please enter the third level category",
}, {
	id: 197,
	cn: "修改二级分类",
	tc: "修改二級分類",
	en: "Modify Secondary Level Category",
}, {
	id: 199,
	cn: "三级分类",
	tc: "三級分類",
	en: "Third Level Category",
}, {
	id: 200,
	cn: "修改三级分类",
	tc: "修改三級分類",
	en: "Modify Third Level Category",
}, {
	id: 201,
	cn: "商品管理",
	tc: "商品管理",
	en: "Product Management",
}, {
	id: 202,
	cn: "商品唯一码",
	tc: "商品唯一碼",
	en: "Product Unique Code",
}, {
	id: 203,
	cn: "请选择",
	tc: "請選擇",
	en: "Please select",
}, {
	id: 204,
	cn: "商品名称",
	tc: "商品名稱",
	en: "Product Name",
}, {
	id: 205,
	cn: "请输入商品SKU",
	tc: "請輸入商品SKU",
	en: "Please enter the product SKU"
}, {
	id: 206,
	cn: "打印商品唯一码",
	tc: "打印商品唯一碼",
	en: "Print Product Unique Code"
}, {
	id: 207,
	cn: "价格 元",
	tc: "價格 元",
	en: "Price (Yuan)",
}, {
	id: 208,
	cn: "体积 cm³",
	tc: "體積 cm³",
	en: "Volume (cm³)",
}, {
	id: 209,
	cn: "重量 g",
	tc: "重量 g",
	en: "Weight (g)",
}, {
	id: 210,
	cn: "重量",
	tc: "重量",
	en: "Weight",
}, {
	id: 211,
	cn: "品牌",
	tc: "品牌",
	en: "Brand",
}, {
	id: 212,
	cn: "请输入商品品牌",
	tc: "請輸入商品品牌",
	en: "Please enter the product brand",
}, {
	id: 213,
	cn: "请选择商品",
	tc: "請選擇商品",
	en: "Please select product(s)",
}, {
	id: 214,
	cn: "单价(RMB)",
	tc: "單價(RMB)",
	en: "Unit Price(RMB)",
}, {
	id: 215,
	cn: "请输入价格",
	tc: "請輸入價格",
	en: "Please enter the price",
}, {
	id: 216,
	cn: "体积",
	tc: "體積",
	en: "Volume",
}, {
	id: 217,
	cn: "请输入重量",
	tc: "請輸入重量",
	en: "Please enter the weight",
}, {
	id: 218,
	cn: "请输入规格",
	tc: "請輸入規格",
	en: "Please enter specifications",
}, {
	id: 219,
	cn: "请选择商品分类",
	tc: "請選擇商品分類",
	en: "Please select the product category"
}, {
	id: 220,
	cn: "请选择是否启用",
	tc: "請選擇是否啟用",
	en: "Please select whether to enable",
}, {
	id: 221,
	cn: "绑定RFID",
	tc: "綁定RFID",
	en: "Bind RFID"
}, {
	id: 222,
	cn: "商品类别",
	tc: "商品類別",
	en: "Product Category"
}, {
	id: 223,
	cn: "货位详情",
	tc: "貨位詳情",
	en: "Storage Unit Details"
}, {
	id: 224,
	cn: "请选择出库策略",
	tc: "請選擇出庫策略",
	en: "Please select the outbound strategy",
}, {
	id: 225,
	cn: "批次控制",
	tc: "批次控制",
	en: "Batch Control",
}, {
	id: 226,
	cn: "上传文件以导入商品",
	tc: "上傳檔案以匯入商品",
	en: "Upload file to import products",
}, {
	id: 227,
	cn: "商品导入模板",
	tc: "商品匯入模板",
	en: "Product Import Template",
}, {
	id: 228,
	cn: "生成唯一码",
	tc: "生成唯一碼",
	en: "Generate Unique Code"
}, {
	id: 229,
	cn: "打印",
	tc: "列印",
	en: "Print"
}, {
	id: 230,
	cn: "溯源码",
	tc: "溯源碼",
	en: "Traceability Code"
}, {
	id: 240,
	cn: "溯源报表",
	tc: "溯源報表",
	en: "Traceability Report"
}, {
	id: 241,
	cn: "RFID记录",
	tc: "RFID記錄",
	en: "RFID Record"
}, {
	id: 242,
	cn: "库内商品种数",
	tc: "庫內商品種數",
	en: "Number of Products in Storage"
}, {
	id: 243,
	cn: "请输入单价",
	tc: "請輸入單價",
	en: "Please enter unit price",
}, {
	id: 244,
	cn: "库内商品总数",
	tc: "庫內商品總數",
	en: "Total Number of Products in Storage"
}, {
	id: 245,
	cn: "请选择是否启用批次控制",
	tc: "請選擇是否啟用批次控制",
	en: "Please select whether to enable batch control",
}, {
	id: 246,
	cn: "出库时间",
	tc: "出庫時間",
	en: "Outbound Time"
}, {
	id: 247,
	cn: "图片格式只能为jpeg格式或者png格式",
	tc: "圖片格式只能為jpeg格式或者png格式",
	en: "The image format can only be jpeg or png",
}, {
	id: 248,
	cn: "暂无RFID信息",
	tc: "暫無RFID資訊",
	en: "No RFID information available"
}, {
	id: 249,
	cn: "商品SKU",
	tc: "商品SKU",
	en: "Product SKU",
}, {
	id: 250,
	cn: "批次编号",
	tc: "批次編號",
	en: "Batch No.",
}, {
	id: 251,
	cn: "序号",
	tc: "序號",
	en: "Serial No.",
}, {
	id: 252,
	cn: "当前状态",
	tc: "當前狀態",
	en: "Current Status"
}, {
	id: 253,
	cn: "库存数量",
	tc: "庫存數量",
	en: "Stock Quantity",
}, {
	id: 254,
	cn: "存储仓库",
	tc: "存儲倉庫",
	en: "Storage Warehouse",
}, {
	id: 255,
	cn: "生成时间",
	tc: "產生時間",
	en: "Creation Time"
}, {
	id: 256,
	cn: "库存状况",
	tc: "庫存狀況",
	en: "Inventory Status",
}, {
	id: 257,
	cn: "PDA管理",
	tc: "PDA管理",
	en: "PDA management",
}, {
	id: 258,
	cn: "请选择PDA",
	tc: "請選擇PDA",
	en: "Please select PDA",
}, {
	id: 259,
	cn: "关联员工",
	tc: "關聯員工",
	en: "Affiliated Employees",
}, {
	id: 260,
	cn: "关联账号",
	tc: "關聯帳號",
	en: "Affiliated Accounts",
}, {
	id: 261,
	cn: "打印机管理",
	tc: "打印機管理",
	en: "Printer Management",
}, {
	id: 262,
	cn: "设备SN",
	tc: "設備SN",
	en: "Device SN",
}, {
	id: 263,
	cn: "设备名称",
	tc: "設備名稱",
	en: "Device Name",
}, {
	id: 264,
	cn: "请输入设备名称",
	tc: "請輸入設備名稱",
	en: "Please enter the device name",
}, {
	id: 265,
	cn: "请输入设备SN",
	tc: "請輸入設備SN",
	en: "Please enter the device SN",
}, {
	id: 266,
	cn: "请输入设备AppKey",
	tc: "請輸入設備AppKey",
	en: "Please enter the device AppKey",
}, {
	id: 267,
	cn: "设备AppKey",
	tc: "設備AppKey",
	en: "Device AppKey",
}, {
	id: 268,
	cn: "请选择打印机",
	tc: "請選擇打印機",
	en: "Please select printer",
}, {
	id: 269,
	cn: "设备ID",
	tc: "設備ID",
	en: "Device ID",
}, {
	id: 271,
	cn: "设备IP",
	tc: "設備IP",
	en: "Device IP",
}, {
	id: 272,
	cn: "请选择设备",
	tc: "請選擇設備",
	en: "Please select device",
}, {
	id: 273,
	cn: "设备回访地址",
	tc: "設備回訪地址",
	en: "Device Return Address",
}, {
	id: 274,
	cn: "查看",
	tc: "查看",
	en: "View",
}, {
	id: 275,
	cn: "请输入设备IP",
	tc: "請輸入設備IP",
	en: "Please enter the device IP",
}, {
	id: 276,
	cn: "摄像头管理",
	tc: "攝像頭管理",
	en: "Camera Management",
}, {
	id: 277,
	cn: "人脸设备",
	tc: "人臉設備",
	en: "Facial Device",
}, {
	id: 278,
	cn: "开始日期",
	tc: "開始日期",
	en: "Start Date",
}, {
	id: 279,
	cn: "结束日期",
	tc: "結束日期",
	en: "End Date",
}, {
	id: 280,
	cn: "创建时间",
	tc: "創建時間",
	en: "Creation Time",
}, {
	id: 281,
	cn: "设备编号",
	tc: "設備編號",
	en: "Device No.",
}, {
	id: 281,
	cn: "在线状态",
	tc: "線上狀態",
	en: "Online Status",
}, {
	id: 282,
	cn: "在线",
	tc: "在線",
	en: "Online",
}, {
	id: 283,
	cn: "离线",
	tc: "離線",
	en: "Offline",
}, {
	id: 284,
	cn: "人员通行证列表",
	tc: "人員通行證列錶",
	en: "Personnel Pass List",
}, {
	id: 285,
	cn: "人员通行记录",
	tc: "人員通行記錄",
	en: "Personnel Passage Record",
}, {
	id: 286,
	cn: "时间",
	tc: "時間",
	en: "Time",
}, {
	id: 287,
	cn: "姓名",
	tc: "姓名",
	en: "Name",
}, {
	id: 288,
	cn: "人脸照片",
	tc: "人臉照片",
	en: "Face Photo",
}, {
	id: 289,
	cn: "IC卡号",
	tc: "IC卡號",
	en: "IC Card No.",
}, {
	id: 290,
	cn: "人员姓名",
	tc: "人員姓名",
	en: "Personnel Name",
}, {
	id: 291,
	cn: "有效期",
	tc: "有效期",
	en: "Validity",
}, {
	id: 292,
	cn: "通行方式",
	tc: "通行方式",
	en: "Passage Method",
}, {
	id: 293,
	cn: "人脸",
	tc: "人臉",
	en: "Face",
}, {
	id: 294,
	cn: "IC卡",
	tc: "IC卡",
	en: "IC Card",
}, {
	id: 295,
	cn: "请选择人员通行证",
	tc: "請選擇人員通行證",
	en: "Please select the personnel pass",
}, {
	id: 296,
	cn: "托盘管理",
	tc: "託盤管理",
	en: "Storage Unit Management",
}, {
	id: 297,
	cn: "托盘编码",
	tc: "託盤編碼",
	en: "Storage Unit Code",
}, {
	id: 298,
	cn: "托盘类型",
	tc: "託盤類型",
	en: "Storage Unit Type",
}, {
	id: 299,
	cn: "请选择类型",
	tc: "請選擇類型",
	en: "Please select the type",
}, {
	id: 300,
	cn: "请选择托盘",
	tc: "請選擇託盤",
	en: "Please select storage unit",
}, {
	id: 301,
	cn: "请输入托盘名称",
	tc: "請輸入託盤名稱",
	en: "Please enter the storage unit name",
}, {
	id: 302,
	cn: "托盘分类",
	tc: "託盤分類",
	en: "Storage Unit Category",
}, {
	id: 303,
	cn: "系统权限管理",
	tc: "系統權限管理",
	en: "System Permission Management"
}, {
	id: 304,
	cn: "调拨单详情",
	tc: "調拨單詳情",
	en: "Transfer Order Details"
}, {
	id: 305,
	cn: "导出商品RFID",
	tc: "導出商品RFID",
	en: "Export Product RFID"
}, {
	id: 306,
	cn: "装箱",
	tc: "裝箱",
	en: "Boxing",
}, {
	id: 307,
	cn: "所在位置",
	tc: "所在位置",
	en: "Location",
}, {
	id: 308,
	cn: "箱内商品数量",
	tc: "箱內商品數量",
	en: "Product Quantity in Box",
}, {
	id: 309,
	cn: "生成数量",
	tc: "生成數量",
	en: "Generate Quantity",
}, {
	id: 310,
	cn: "商品列表",
	tc: "商品列表",
	en: "Product List",
}, {
	id: 311,
	cn: "请输入数量",
	tc: "請輸入數量",
	en: "Please enter quantity",
}, {
	id: 312,
	cn: "今日入库商品总数",
	tc: "今日入庫商品總數",
	en: "Total Number of Products Inbound Today"
}, {
	id: 313,
	cn: "选择商品",
	tc: "選擇商品",
	en: "Select product",
}, {
	id: 314,
	cn: "数量",
	tc: "數量",
	en: "Quantity",
}, {
	id: 315,
	cn: "该商品库存不为0，暂不可删除",
	tc: "該商品庫存不為0，暫不可删除",
	en: "This product inventory is not 0 and cannot be deleted for the time being",
}, {
	id: 316,
	cn: "今日出库商品总数",
	tc: "今日出庫商品總數",
	en: "Total Number of Products Outbound Today"
}, {
	id: 317,
	cn: "箱内商品总数量",
	tc: "箱內商品總數量",
	en: "Total product quanity in the box",
}, {
	id: 318,
	cn: "商品信息",
	tc: "商品信息",
	en: "Product Information",
}, {
	id: 319,
	cn: "商品图片",
	tc: "商品圖片",
	en: "Product Images",
}, {
	id: 320,
	cn: "单位名称",
	tc: "單位名稱",
	en: "Unit Name",
}, {
	id: 321,
	cn: "请输入单位名称",
	tc: "請輸入單位名稱",
	en: "Please enter the unit name",
}, {
	id: 322,
	cn: "人员类型",
	tc: "人員類型",
	en: "Personnel Type",
}, {
	id: 323,
	cn: "二维码",
	tc: "二維碼",
	en: "QR Code",
}, {
	id: 324,
	cn: "通行类型",
	tc: "通行類型",
	en: "Passage Type",
}, {
	id: 325,
	cn: "有限期内通行",
	tc: "有限期內通行",
	en: "Pass within the validity period",
}, {
	id: 326,
	cn: "无限制",
	tc: "無限制",
	en: "No Restrictions",
}, {
	id: 327,
	cn: "请选择通行人员",
	tc: "請選擇通行人員",
	en: "Please select personnel for passage",
}, {
	id: 328,
	cn: "请输入IC卡号",
	tc: "請輸入IC卡號",
	en: "Please enter the IC card No.",
}, {
	id: 329,
	cn: "示例",
	tc: "示例",
	en: "Example",
}, {
	id: 330,
	cn: "图片大小须小于300KB",
	tc: "圖片大小須小於300KB",
	en: "Image size must be less than 300KB",
}, {
	id: 331,
	cn: "图片需上传员工正脸照片",
	tc: "圖片需上傳員工正臉照片",
	en: "Images should be uploaded with a full face photo of the employee",
}, {
	id: 332,
	cn: "人脸图片",
	tc: "人臉圖片",
	en: "Face Photo",
}, {
	id: 333,
	cn: "重新拍摄",
	tc: "重新拍攝",
	en: "Re-shoot",
}, {
	id: 334,
	cn: "入库通知单",
	tc: "入庫通知單",
	en: "Inbound Management"
}, {
	id: 335,
	cn: "入库单号",
	tc: "入庫單號",
	en: "Inbound No.",
}, {
	id: 336,
	cn: "溯源详情",
	tc: "溯源詳情",
	en: "Provenance Details"
}, {
	id: 337,
	cn: "入库类型",
	tc: "入庫類型",
	en: "Inbound type",
}, {
	id: 338,
	cn: "订单来源",
	tc: "訂單來源",
	en: "Order Sources",
}, {
	id: 339,
	cn: "创建人",
	tc: "創建人",
	en: "Founder",
}, {
	id: 340,
	cn: "操作员",
	tc: "操作員",
	en: "Operator",
}, {
	id: 341,
	cn: "创建入库单",
	tc: "創建入庫單",
	en: "Create Inbound Orders",
}, {
	id: 342,
	cn: "请选择入库类型",
	tc: "請選擇入庫類型",
	en: "Please select inbound type",
}, {
	id: 343,
	cn: "请选择订单来源",
	tc: "請選擇訂單來源",
	en: "Please select order source",
}, {
	id: 344,
	cn: "关联单号",
	tc: "關聯單號",
	en: "Associated Order No.",
}, {
	id: 345,
	cn: "请输入关联单号",
	tc: "請輸入關聯單號",
	en: "Please enter the associated order no.",
}, {
	id: 351,
	cn: "请选择操作员",
	tc: "請選擇操作員",
	en: "Please select operator",
}, {
	id: 352,
	cn: "用户",
	tc: "用戶",
	en: "User",
}, {
	id: 353,
	cn: "请选择用户",
	tc: "請選擇用戶",
	en: "Please select user",
}, {
	id: 354,
	cn: "请选择用户类型",
	tc: "請選擇用戶類型",
	en: "Please select user type",
}, {
	id: 355,
	cn: "入库数量",
	tc: "入庫數量",
	en: "Inbound Quantity",
}, {
	id: 356,
	cn: "选择客户",
	tc: "選擇客戶",
	en: "Select Customer",
}, {
	id: 357,
	cn: "入库时间",
	tc: "入庫時間",
	en: "Inbound Time"
}, {
	id: 358,
	cn: "请完善商品信息",
	tc: "請完善商品信息",
	en: "Please complete the product information",
}, {
	id: 359,
	cn: "入库单详情",
	tc: "入庫單詳情",
	en: "Inbound Order Details",
}, {
	id: 360,
	cn: "打印入库单",
	tc: "打印入庫單",
	en: "Print the inbound order",
}, {
	id: 361,
	cn: "预报数量",
	tc: "預報數量",
	en: "Forecast Quantity",
}, {
	id: 362,
	cn: "出库通知单",
	tc: "出庫通知單",
	en: "Outbound Management",
}, {
	id: 363,
	cn: "出库单号",
	tc: "出庫單號",
	en: "Outbound Order No.",
}, {
	id: 364,
	cn: "出库类型",
	tc: "出庫類型",
	en: "Outbound type",
}, {
	id: 365,
	cn: "创建出库单",
	tc: "創建出庫單",
	en: "Create Outbound Orders",
}, {
	id: 366,
	cn: "是否亮灯",
	tc: "是否亮燈",
	en: "Whether the light is on",
}, {
	id: 367,
	cn: "请选择出库类型",
	tc: "請選擇出庫類型",
	en: "Please select outbound type",
}, {
	id: 368,
	cn: "移库管理",
	tc: "移庫管理",
	en: "Removal Management",
}, {
	id: 369,
	cn: "移库单号",
	tc: "移庫單號",
	en: "Removal Order No. ",
}, {
	id: 370,
	cn: "客户",
	tc: "客戶",
	en: "Customers",
}, {
	id: 371,
	cn: "通过",
	tc: "通過",
	en: "Pass",
}, {
	id: 372,
	cn: "拒绝",
	tc: "拒絕",
	en: "Reject",
}, {
	id: 373,
	cn: "是否通过该申请？",
	tc: "是否通過該申請？",
	en: "Approve the application or not",
}, {
	id: 374,
	cn: "已通过",
	tc: "已通過",
	en: "Passed",
}, {
	id: 375,
	cn: "已拒绝",
	tc: "已拒絕",
	en: "Rejected",
}, {
	id: 376,
	cn: "移库单详情",
	tc: "移庫單詳情",
	en: "Removal Order Details",
}, {
	id: 377,
	cn: "移动仓库",
	tc: "移動倉庫",
	en: "Mobile Warehouse",
}, {
	id: 378,
	cn: "移库类型",
	tc: "移庫類型",
	en: "Removal Type",
}, {
	id: 379,
	cn: "商品移库",
	tc: "商品移庫",
	en: "Product Removal",
}, {
	id: 380,
	cn: "整托移库",
	tc: "整托移庫",
	en: "Whote Storage Unit Removal",
}, {
	id: 381,
	cn: "原货位",
	tc: "原貨位",
	en: "Original Storage Unit"
}, {
	id: 382,
	cn: "目标货位",
	tc: "目標貨位",
	en: "Destination Storage Unit",
}, {
	id: 383,
	cn: "移库数量",
	tc: "移庫數量",
	en: "Removal Quantity",
}, {
	id: 384,
	cn: "调拨管理",
	tc: "調撥管理",
	en: "Transfer Management",
}, {
	id: 385,
	cn: "调拨单号",
	tc: "調撥單號",
	en: "Transfer Order No.",
}, {
	id: 386,
	cn: "原仓库",
	tc: "原倉庫",
	en: "Former Warehouse",
}, {
	id: 387,
	cn: "目标仓库",
	tc: "目標倉庫",
	en: "Target Warehouse",
}, {
	id: 388,
	cn: "盘点管理",
	tc: "盤點管理",
	en: "Stock-taking Management",
}, {
	id: 389,
	cn: "创建移库单",
	tc: "創建移庫單",
	en: "Create Removal Order",
}, {
	id: 390,
	cn: "移库仓库",
	tc: "移庫倉庫",
	en: "Re-located Warehouse",
}, {
	id: 391,
	cn: "订单状态",
	tc: "訂單狀態",
	en: "Order Status",
}, {
	id: 392,
	cn: "盘点单号",
	tc: "盤點單號",
	en: "Stock-taking Order No.",
}, {
	id: 393,
	cn: "创建盘点单",
	tc: "創建盤點單",
	en: "Create Stock-taking Order",
}, {
	id: 394,
	cn: "盘点仓库",
	tc: "盤點倉庫",
	en: "Stock-taking Warehouse",
}, {
	id: 395,
	cn: "实盘数量",
	tc: "實盤數量",
	en: "Firm Offer Quantity",
}, {
	id: 396,
	cn: "盘点结果",
	tc: "盤點結果",
	en: "Stock-taking Result",
}, {
	id: 397,
	cn: "库存明细",
	tc: "庫存明細",
	en: "Inventory Breakdown",
}, {
	id: 398,
	cn: "存储货位",
	tc: "存儲貨位",
	en: "Storage Unit"
}, {
	id: 399,
	cn: "存放时长 天",
	tc: "存放時長 天",
	en: "Storage Duration (Days)",
}, {
	id: 400,
	cn: "总数量",
	tc: "總數量",
	en: "Total Number",
}, {
	id: 401,
	cn: "可用数量",
	tc: "可用數量",
	en: "Quantity Available",
}, {
	id: 402,
	cn: "冻结数量",
	tc: "凍結數量",
	en: "Quantity Frozen ",
}, {
	id: 403,
	cn: "总重量",
	tc: "總重量",
	en: "Gross weight",
}, {
	id: 404,
	cn: "",
	tc: "",
	en: "",
}, {
	id: 405,
	cn: "库存报表",
	tc: "庫存報表",
	en: "Inventory Statement",
}, {
	id: 406,
	cn: "绑定到的商品SKU",
	tc: "綁定到的商品SKU",
	en: "Bound Product SKU"
}, {
	id: 407,
	cn: "总价(RMB)",
	tc: "總價(RMB)",
	en: "Total Price (RMB)",
}, {
	id: 408,
	cn: "库存台账",
	tc: "庫存台賬",
	en: "Inventory Ledger",
}, {
	id: 409,
	cn: "相关单号",
	tc: "相關單號",
	en: "Relevant Order No.",
}, {
	id: 410,
	cn: "台账类型",
	tc: "台賬類型",
	en: "Type of Ledger",
}, {
	id: 411,
	cn: "订单类型",
	tc: "台賬類型",
	en: "Order Type",
}, {
	id: 412,
	cn: "订单完成时间",
	tc: "訂單完成時間",
	en: "Order Completion Time",
}, {
	id: 413,
	cn: "请选择时间",
	tc: "請選擇時間",
	en: "Please select time",
}, {
	id: 414,
	cn: "操作人",
	tc: "操作人",
	en: "Operator"
}, {
	id: 415,
	cn: "入库明细",
	tc: "入庫明細",
	en: "Inbound Details",
}, {
	id: 416,
	cn: "出库明细",
	tc: "出庫明細",
	en: "Outbound Details",
}, {
	id: 417,
	cn: "出库数量",
	tc: "出庫數量",
	en: "Outbound Quantity",
}, {
	id: 418,
	cn: "您的体验账号已到期，如需进一步体验和沟通<br />请扫描下方二维码联系我们",
	tc: "您的體驗帳號已到期，如需進一步體驗和溝通<br />請掃描下方二維碼聯繫我們",
	en: "Your trial account has expired. For further experience or communication, please contact us by scanning the QR code below",
}, {
	id: 419,
	cn: "专属客服顾问",
	tc: "專屬客服顧問",
	en: "Customer Service",
}, {
	id: 420,
	cn: "开始时间",
	tc: "開始時間",
	en: "Start Time",
}, {
	id: 421,
	cn: "结束时间",
	tc: "結束時間",
	en: "End Time",
}, {
	id: 422,
	cn: "自定义时间",
	tc: "自定義時間",
	en: "Customize Time",
}, {
	id: 423,
	cn: "提示",
	tc: "提示",
	en: "Tips",
}, {
	id: 424,
	cn: "联系人",
	tc: "聯繫人",
	en: "Contact",
}, {
	id: 425,
	cn: "联系电话",
	tc: "聯繫電話",
	en: "Phone No. ",
}, {
	id: 426,
	cn: "请输入联系电话",
	tc: "請輸入聯繫電話",
	en: "Please enter contact name",
}, {
	id: 427,
	cn: "打印货位编码",
	tc: "打印貨位編碼",
	en: "Print Storage Unit Code"
}, {
	id: 428,
	cn: "规格",
	tc: "規格",
	en: "Specifications",
}, {
	id: 429,
	cn: "请选择关联人员",
	tc: "請選擇關聯人員",
	en: "Please select contact person",
}, {
	id: 430,
	cn: "PDA账号",
	tc: "PDA帳號",
	en: "PDA Account",
}, {
	id: 431,
	cn: "系统自动导入",
	tc: "系統自動導入",
	en: "Automatic System Import",
}, {
	id: 432,
	cn: "请选择通行人员",
	tc: "請選擇通行人員",
	en: "Please select personnel for passage",
}, {
	id: 433,
	cn: "请选择有效日期",
	tc: "請選擇有效日期",
	en: "Please select validity date",
}, {
	id: 434,
	cn: "请输入IC卡号",
	tc: "請輸入IC卡號",
	en: "Please enter the IC card no.",
}, {
	id: 435,
	cn: "出库单详情",
	tc: "出庫單詳情",
	en: "Outbound Order Details",
}, {
	id: 436,
	cn: "打印出库单",
	tc: "打印出庫單",
	en: "Print Outbound Orders",
}, {
	id: 437,
	cn: "创建调拨单",
	tc: "創建調撥單",
	en: "Create Transfer Order",
}, {
	id: 438,
	cn: "邮编",
	tc: "郵編",
	en: "Zip Code",
}, {
	id: 439,
	cn: "请输入邮编",
	tc: "請輸入郵編",
	en: "Please enter the Zip Code",
}, {
	id: 440,
	cn: "创建成功",
	tc: "創建成功",
	en: "Create Sucessfully",
}, {
	id: 441,
	cn: "请选择原仓库",
	tc: "請選擇原倉庫",
	en: "Please select the former warehouse",
}, {
	id: 442,
	cn: "请选择目标仓库",
	tc: "請選擇目標倉庫",
	en: "Please select the target warehouse",
}, {
	id: 443,
	cn: "权限管理",
	tc: "權限管理",
	en: "Privileges Management",
}, {
	id: 444,
	cn: "类型",
	tc: "類型",
	en: "Type",
}, {
	id: 445,
	cn: "菜单权限",
	tc: "菜單權限",
	en: "Menu Privileges",
}, {
	id: 446,
	cn: "功能权限",
	tc: "功能權限",
	en: "Function Privileges",
}, {
	id: 447,
	cn: "权限类型",
	tc: "權限類型",
	en: "Privilege Type",
}, {
	id: 448,
	cn: "员工管理",
	tc: "員工管理",
	en: "Employees Management",
}, {
	id: 449,
	cn: "角色类型",
	tc: "角色類型",
	en: "Role Type",
}, {
	id: 450,
	cn: "服务目标数",
	tc: "服務目標數",
	en: "Service Objective No.",
}, {
	id: 451,
	cn: "重置密码",
	tc: "重置密碼",
	en: "Reset Password",
}, {
	id: 452,
	cn: "绑定",
	tc: "綁定",
	en: "Binding",
}, {
	id: 453,
	cn: "创建员工",
	tc: "創建員工",
	en: "Create Employee",
}, {
	id: 454,
	cn: "请选择员工",
	tc: "請選擇員工",
	en: "Please select employee",
}, {
	id: 455,
	cn: "密码",
	tc: "密碼",
	en: "Password",
}, {
	id: 456,
	cn: "请选择角色类型",
	tc: "請選擇角色類型",
	en: "Please select role type",
}, {
	id: 457,
	cn: "到期时间",
	tc: "到期時間",
	en: "Expiration Date",
}, {
	id: 458,
	cn: "请选择到期时间",
	tc: "請選擇到期時間",
	en: "Please select expiration date",
}, {
	id: 459,
	cn: "请输入姓名",
	tc: "請輸入姓名",
	en: "Please enter your name",
}, {
	id: 460,
	cn: "服务目标列表",
	tc: "服務目標列表",
	en: "Service Objective List",
}, {
	id: 461,
	cn: "请上传头像",
	tc: "請上傳頭像",
	en: "Please upload profile picture",
}, {
	id: 463,
	cn: "请选择服务目标",
	tc: "請選擇服務目標",
	en: "Please select service objective",
}, {
	id: 464,
	cn: "选择服务目标",
	tc: "選擇服務目標",
	en: "Select Service Objective",
}, {
	id: 465,
	cn: "仓库权限",
	tc: "倉庫權限",
	en: "Warehouse Privileges",
}, {
	id: 467,
	cn: "账号",
	tc: "帳號",
	en: "Account",
}, {
	id: 468,
	cn: "默认仓库",
	tc: "默認倉庫",
	en: "Default Warehouse",
}, {
	id: 469,
	cn: "请选择仓库权限",
	tc: "請選擇倉庫權限",
	en: "Please select warehouse privileges",
}, {
	id: 470,
	cn: "添加仓库权限",
	tc: "添加倉庫權限",
	en: "Add Warehouse Privileges",
}, {
	id: 471,
	cn: "员工",
	tc: "員工",
	en: "Employees",
}, {
	id: 472,
	cn: "请选择人员",
	tc: "請選擇人員",
	en: "Please select personnel",
}, {
	id: 479,
	cn: "员工卡绑定",
	tc: "員工卡綁定",
	en: "Employee Card Binding",
}, {
	id: 480,
	cn: "原仓库操作员",
	tc: "原倉庫操作員",
	en: "Original Warehouse Operator"
}, {
	id: 481,
	cn: "已选择员工",
	tc: "已選擇員工",
	en: "Selected Employees",
}, {
	id: 482,
	cn: "员工手机号",
	tc: "員工手機號",
	en: "Employee's Cell Phone",
}, {
	id: 483,
	cn: "员工名称",
	tc: "員工名稱",
	en: "Employee Name",
}, {
	id: 484,
	cn: "请输入RFID",
	tc: "請輸入RFID",
	en: "Please enter RFID",
}, {
	id: 485,
	cn: "RFID标签管理",
	tc: "RFID标签管理",
	en: "RFID Label Management",
}, {
	id: 486,
	cn: "RFID标签总数",
	tc: "RFID標籤總數",
	en: "Total RFID Labels No.",
}, {
	id: 487,
	cn: "已使用RFID标签数",
	tc: "已使用RFID標籤數",
	en: "Number of RFID Labels Used",
}, {
	id: 488,
	cn: "未使用RFID标签数",
	tc: "未使用RFID標籤數",
	en: "Number of RFID Labels Unused",
}, {
	id: 489,
	cn: "请输入商品RFID",
	tc: "請輸入商品RFID",
	en: "Please enter product RFID",
}, {
	id: 490,
	cn: "导入时间",
	tc: "導入時間",
	en: "Import Time",
}, {
	id: 491,
	cn: "请选择日期",
	tc: "請選擇日期",
	en: "Please select date",
}, {
	id: 492,
	cn: "待使用RFID标签",
	tc: "待使用RFID標籤",
	en: "RFID Labels to Be Used",
}, {
	id: 493,
	cn: "已使用RFID标签",
	tc: "已使用RFID標籤",
	en: "RFID Labels Used",
}, {
	id: 494,
	cn: "所属分类",
	tc: "所屬分類",
	en: "Subsidiary Category",
}, {
	id: 497,
	cn: "快速选择",
	tc: "快速選擇",
	en: "Quick Select",
}, {
	id: 498,
	cn: "绑定商品",
	tc: "綁定商品",
	en: "Bind Products",
}, {
	id: 499,
	cn: "请输入商品唯一码或商品SKU",
	tc: "請輸入商品唯一码或商品SKU",
	en: "Please enter product unique code or product SKU"
}, {
	id: 500,
	cn: "从商品列表选择",
	tc: "從商品列表選擇",
	en: "Select from product list",
}, {
	id: 501,
	cn: "已选择商品",
	tc: "已選擇商品",
	en: "Selected Products",
}, {
	id: 502,
	cn: "绑定数量",
	tc: "綁定數量",
	en: "Binding Quantity",
}, {
	id: 503,
	cn: "请输入绑定数量",
	tc: "請輸入綁定數量",
	en: "Please enter binding quantity",
}, {
	id: 504,
	cn: "温湿度传感器管理",
	tc: "溫濕度感測器管理",
	en: "Temperature and Humidity Sensor Management",
}, {
	id: 505,
	cn: "传感器ID",
	tc: "傳感器ID",
	en: "Sensor ID",
}, {
	id: 506,
	cn: "请输入传感器ID",
	tc: "請輸入傳感器ID",
	en: "Please enter sensor ID",
}, {
	id: 507,
	cn: "传感器名称",
	tc: "傳感器名稱",
	en: "Sensor Name",
}, {
	id: 508,
	cn: "请输入传感器名称",
	tc: "請輸入傳感器名稱",
	en: "Please enter sensor name",
}, {
	id: 509,
	cn: "关联仓库",
	tc: "關聯倉庫",
	en: "Related Warehouse",
}, {
	id: 510,
	cn: "传感器IP",
	tc: "傳感器IP",
	en: "Sensor IP",
}, {
	id: 511,
	cn: "请输入传感器IP",
	tc: "請輸入傳感器IP",
	en: "Please enter sensor IP",
}, {
	id: 512,
	cn: "关联区域",
	tc: "關聯區域",
	en: "Related Area",
}, {
	id: 513,
	cn: "关联巷道",
	tc: "關聯巷道",
	en: "Affiliated Laneway",
}, {
	id: 514,
	cn: "关联货柜",
	tc: "關聯貨櫃",
	en: "Affiliated Shelf",
}, {
	id: 515,
	cn: "传感器状态",
	tc: "传感器狀態",
	en: "Sensor Status",
}, {
	id: 517,
	cn: "请选择传感器ID",
	tc: "請選擇感測器ID",
	en: "Please select sensor ID",
}, {
	id: 518,
	cn: "请选择传感器",
	tc: "請選擇感測器",
	en: "Please select sensor",
}, {
	id: 519,
	cn: "巷道灯管理",
	tc: "巷道燈管理",
	en: "Laneway Light Management",
}, {
	id: 520,
	cn: "请选择巷道灯",
	tc: "請選擇巷道燈",
	en: "Please select Laneway Light",
}, {
	id: 521,
	cn: "巷道灯IP",
	tc: "巷道燈IP",
	en: "Laneway Light IP",
}, {
	id: 522,
	cn: "巷道灯名称",
	tc: "巷道燈名稱",
	en: "Laneway Light Name",
}, {
	id: 523,
	cn: "请输入巷道灯IP",
	tc: "請輸入巷道燈I",
	en: "Please enter Laneway Light IP",
}, {
	id: 524,
	cn: "请输入巷道灯名称",
	tc: "請輸入巷道燈名稱",
	en: "Please enter Laneway Light name",
}, {
	id: 525,
	cn: "PTL标签管理",
	tc: "PTL標籤管理",
	en: "PTL Label Management",
}, {
	id: 526,
	cn: "关联货位",
	tc: "關聯貨位",
	en: "Affiliated Storage Unit",
}, {
	id: 527,
	cn: "标签地址",
	tc: "標籤地址",
	en: "Label Address",
}, {
	id: 528,
	cn: "关联巷道灯",
	tc: "關聯巷道燈",
	en: "Affiliated Laneway Light",
}, {
	id: 529,
	cn: "请选择标签",
	tc: "請選擇標籤",
	en: "Please select label",
}, {
	id: 530,
	cn: "入库管理",
	tc: "入庫管理",
	en: "Inbound Management"
}, {
	id: 531,
	cn: "IP地址",
	tc: "IP地址",
	en: "IP Address",
}, {
	id: 532,
	cn: "天线路数",
	tc: "天線路數",
	en: "Number of Antenna",
}, {
	id: 533,
	cn: "请选择天线",
	tc: "請選擇天線",
	en: "Please select antenna",
}, {
	id: 534,
	cn: "天线名称",
	tc: "天線名稱",
	en: "Antenna Name",
}, {
	id: 535,
	cn: "请输入天线名称",
	tc: "請輸入天線名稱",
	en: "Please enter antenna name",
}, {
	id: 536,
	cn: "请输入IP地址",
	tc: "請輸入IP地址",
	en: "Please enter IP address",
}, {
	id: 537,
	cn: "请输入天线路数",
	tc: "請輸入天線路數",
	en: "Please enter number of antennas",
}, {
	id: 538,
	cn: "目标仓库操作员",
	tc: "目標倉庫操作員",
	en: "Target Warehouse Operator"
}, {
	id: 540,
	cn: "保存成功",
	tc: "儲存成功",
	en: "Save successful"
}, {
	id: 541,
	cn: "创建员工账号",
	tc: "創建員工帳號",
	en: "Create Employee Account"
}, {
	id: 542,
	cn: "姓名不能为空",
	tc: "姓名不能為空",
	en: "Name cannot be empty"
}, {
	id: 543,
	cn: "预警灯管理",
	tc: "預警燈管理",
	en: "Warning Light Management",
}, {
	id: 544,
	cn: "请选择预警灯",
	tc: "請選擇預警燈",
	en: "Please select warning light",
}, {
	id: 545,
	cn: "试用时间",
	tc: "試用時間",
	en: "Expiration date",
}, {
	id: 546,
	cn: "商品类别统计",
	tc: "商品類別統計",
	en: "Material category statistics",
}, {
	id: 547,
	cn: "请选择报表数据",
	tc: "請選擇報表數據",
	en: "Please select report data",
}, {
	id: 548,
	cn: "货位类型名称",
	tc: "貨位類型名稱",
	en: "Storage unit type name"
}, {
	id: 549,
	cn: "入库类型名称",
	tc: "入庫類型名稱",
	en: "Inbound type name",
}, {
	id: 550,
	cn: "出库类型名称",
	tc: "出庫類型名稱",
	en: "Outbound type name",
}, {
	id: 551,
	cn: "仓库总数",
	tc: "倉庫總數",
	en: "Total warehouses",
}, {
	id: 552,
	cn: "您正在执行删除操作，是否确认并继续？",
	tc: "您正在執行刪除操作，是否確認並繼續？",
	en: "Are you sure you want to delete this item?"
}, {
	id: 553,
	cn: "货位类型名称不能为空",
	tc: "貨位類型名稱不能為空",
	en: "Storage unit type name cannot be empty"
}, {
	id: 554,
	cn: "出库类型名称不能为空",
	tc: "出庫類型名稱不能為空",
	en: "Outbound type name cannot be empty"
}, {
	id: 555,
	cn: "入库类型名称不能为空",
	tc: "入庫類型名稱不能為空",
	en: "Inbound type name cannot be empty"
}, {
	id: 556,
	cn: "区域类型名称不能为空",
	tc: "區域類型名稱不能為空",
	en: "Region type name cannot be empty"
}, {
	id: 557,
	cn: "编辑货柜",
	tc: "編輯貨櫃",
	en: "Edit shelf"
}, {
	id: 558,
	cn: "新建货柜",
	tc: "新建貨櫃",
	en: "New shelf"
}, {
	id: 559,
	cn: "编辑仓库",
	tc: "編輯倉庫",
	en: "Edit warehouse"
}, {
	id: 560,
	cn: "新建仓库",
	tc: "新建倉庫",
	en: "New warehouse"
}, {
	id: 561,
	cn: "联系人不能为空",
	tc: "聯絡人不能為空",
	en: "Contact person cannot be empty"
}, {
	id: 562,
	cn: "联系电话不能为空",
	tc: "聯絡電話不能為空",
	en: "Contact phone cannot be empty"
}, {
	id: 563,
	cn: "地区不能为空",
	tc: "地區不能為空",
	en: "Area cannot be empty"
}, {
	id: 564,
	cn: "详细地址不能为空",
	tc: "詳細地址不能為空",
	en: "Address cannot be empty"
}, {
	id: 565,
	cn: "状态不能为空",
	tc: "狀態不能為空",
	en: "Status cannot be empty"
}, {
	id: 566,
	cn: "编辑区域",
	tc: "編輯區域",
	en: "Edit region"
}, {
	id: 567,
	cn: "新建区域",
	tc: "新建區域",
	en: "New region"
}, {
	id: 568,
	cn: "区域编号",
	tc: "區域編號",
	en: "Region number"
}, {
	id: 569,
	cn: "编辑货位",
	tc: "編輯貨位",
	en: "Edit storage unit"
}, {
	id: 570,
	cn: "新建货位",
	tc: "新建貨位",
	en: "New storage unit"
}, {
	id: 571,
	cn: "货位编号",
	tc: "貨位編號",
	en: "Storage unit number"
}, {
	id: 572,
	cn: "账号不能为空",
	tc: "帳號不能為空",
	en: "Account cannot be empty"
}, {
	id: 573,
	cn: "密码不能为空",
	tc: "密碼不能為空",
	en: "Password cannot be empty"
}, {
	id: 574,
	cn: "登录成功",
	tc: "登入成功",
	en: "Login successful"
}, {
	id: 575,
	cn: "暂未开放",
	tc: "暫未開放",
	en: "Not open yet"
}, {
	id: 576,
	cn: "校验失败",
	tc: "驗證失敗",
	en: "Verification failed"
}, {
	id: 577,
	cn: "校验成功",
	tc: "驗證成功",
	en: "Verification successful"
}, {
	id: 578,
	cn: "上一步",
	tc: "上一步",
	en: "Previous step"
}, {
	id: 579,
	cn: "校验",
	tc: "驗證",
	en: "Verification"
}, {
	id: 580,
	cn: "校验并提交",
	tc: "驗證並提交",
	en: "Verify and submit"
}, {
	id: 581,
	cn: "正在校验...",
	tc: "正在驗證...",
	en: "Verifying..."
}, {
	id: 582,
	cn: "上传文件",
	tc: "上傳檔案",
	en: "Upload file"
}, {
	id: 583,
	cn: "数据预览",
	tc: "資料預覽",
	en: "Data preview"
}, {
	id: 584,
	cn: "数据校验",
	tc: "資料驗證",
	en: "Data verification"
}, {
	id: 585,
	cn: "成功导入",
	tc: "成功匯入",
	en: "Successfully imported"
}, {
	id: 586,
	cn: "文件上传失败",
	tc: "檔案上傳失敗",
	en: "File upload failed"
}, {
	id: 587,
	cn: "文件校验完成",
	tc: "檔案驗證完成",
	en: "File verification complete"
}, {
	id: 588,
	cn: "文件上传失败，请重新尝试",
	tc: "檔案上傳失敗，請重新嘗試",
	en: "File upload failed, please try again"
}, {
	id: 589,
	cn: "数据提交中...",
	tc: "資料提交中...",
	en: "Submitting data..."
}, {
	id: 590,
	cn: "提交成功",
	tc: "提交成功",
	en: "Submission successful"
}, {
	id: 591,
	cn: "模板",
	tc: "模板",
	en: "Template"
}, {
	id: 592,
	cn: "选择货柜",
	tc: "選擇貨櫃",
	en: "Select shelf"
}, {
	id: 593,
	cn: "确认",
	tc: "確認",
	en: "Confirm"
}, {
	id: 594,
	cn: "货位导入模板",
	tc: "貨位匯入模板",
	en: "Storage unit import template"
}, {
	id: 595,
	cn: "区域导入模板",
	tc: "區域匯入模板",
	en: "Region import template"
}, {
	id: 596,
	cn: "仓库导入模板",
	tc: "倉庫匯入模板",
	en: "Warehouse import template"
}, {
	id: 597,
	cn: "先进先出",
	tc: "先進先出",
	en: "First in first out"
}, {
	id: 598,
	cn: "区域总数",
	tc: "區域總數",
	en: "Total regions"
}, {
	id: 599,
	cn: "货位总数",
	tc: "貨位總數",
	en: "Total storage units"
}, {
	id: 600,
	cn: "货柜总数",
	tc: "貨櫃總數",
	en: "Total shelves"
}, {
	id: 601,
	cn: "所属区域编号",
	tc: "所屬區域編號",
	en: "Belonging to region number"
}, {
	id: 602,
	cn: "商品总数",
	tc: "商品總數",
	en: "Total products"
}, {
	id: 603,
	cn: "预警商品总数",
	tc: "預警商品總數",
	en: "Total warning products"
}, {
	id: 604,
	cn: "一级分类总数",
	tc: "一級分類總數",
	en: "Total first-level categories"
}, {
	id: 605,
	cn: "二级分类总数",
	tc: "二級分類總數",
	en: "Total second-level categories"
}, {
	id: 606,
	cn: "货柜编号",
	tc: "貨櫃編號",
	en: "Shelf number"
}, {
	id: 607,
	cn: "数据导入",
	tc: "資料匯入",
	en: "Data import"
}, {
	id: 608,
	cn: "货柜导入模板",
	tc: "貨櫃匯入模板",
	en: "Shelf import template"
}, {
	id: 609,
	cn: "货柜管理",
	tc: "貨櫃管理",
	en: "Shelf management"
}, {
	id: 610,
	cn: "区域数量",
	tc: "區域數量",
	en: "Region quantity"
}, {
	id: 611,
	cn: "导出模板",
	tc: "導出模板",
	en: "Export template"
}, {
	id: 612,
	cn: "文件上传完成",
	tc: "檔案上傳完成",
	en: "File upload complete"
}, {
	id: 613,
	cn: "上传照片",
	tc: "上傳照片",
	en: "Upload photo"
}, {
	id: 614,
	cn: "盘点方式",
	tc: "盤點方式",
	en: "Inventory method"
}, {
	id: 615,
	cn: "盘点类型",
	tc: "盤點類型",
	en: "Inventory type"
}, {
	id: 616,
	cn: "盘点货位",
	tc: "盤點貨位",
	en: "Inventory storage unit"
}, {
	id: 617,
	cn: "盘点仓库不能为空",
	tc: "盤點倉庫不能為空",
	en: "Inventory warehouse cannot be empty"
}, {
	id: 618,
	cn: "盘点方式不能为空",
	tc: "盤點方式不能為空",
	en: "Inventory method cannot be empty"
}, {
	id: 619,
	cn: "操作员不能为空",
	tc: "操作員不能為空",
	en: "Operator cannot be empty"
}, {
	id: 620,
	cn: "商品盘点",
	tc: "商品盤點",
	en: "Product inventory"
}, {
	id: 621,
	cn: "入库类型不能为空",
	tc: "入庫類型不能為空",
	en: "Inbound type cannot be empty"
}, {
	id: 622,
	cn: "存储仓库不能为空",
	tc: "儲存倉庫不能為空",
	en: "Storage warehouse cannot be empty"
}, {
	id: 623,
	cn: "请确认商品信息",
	tc: "請確認商品資訊",
	en: "Please confirm product information"
}, {
	id: 624,
	cn: "出库类型不能为空",
	tc: "出庫類型不能為空",
	en: "Outbound type cannot be empty"
}, {
	id: 625,
	cn: "库存不足",
	tc: "庫存不足",
	en: "Insufficient inventory"
}, {
	id: 626,
	cn: "库内数量",
	tc: "庫內數量",
	en: "Inventory quantity"
}, {
	id: 627,
	cn: "实入数量",
	tc: "實入數量",
	en: "Actual quantity"
}, {
	id: 628,
	cn: "盘点单详情",
	tc: "盤點單詳情",
	en: "Inventory detail"
}, {
	id: 629,
	cn: "拒绝理由",
	tc: "拒絕原因",
	en: "Rejection reason"
}, {
	id: 630,
	cn: "是否通过该商品的盘点审核？",
	tc: "是否通過該商品的盤點審核？",
	en: "Is the inventory audit for this product approved?"
}, {
	id: 631,
	cn: "出库方式",
	tc: "出庫方式",
	en: "Outbound method"
}, {
	id: 632,
	cn: "实出数量",
	tc: "實出數量",
	en: "Actual quantity"
}, {
	id: 633,
	cn: "推荐货位",
	tc: "推薦貨位",
	en: "Recommended storage unit"
}, {
	id: 634,
	cn: "盘点总数",
	tc: "盤點總數",
	en: "Total inventory"
}, {
	id: 635,
	cn: "待审核",
	tc: "待審核",
	en: "Pending review"
}, {
	id: 636,
	cn: "已完成",
	tc: "已完成",
	en: "Completed"
}, {
	id: 637,
	cn: "订单总数",
	tc: "訂單總數",
	en: "Total orders"
}, {
	id: 638,
	cn: "待完成",
	tc: "待完成",
	en: "Pending completion"
}, {
	id: 639,
	cn: "入库方式",
	tc: "入庫方式",
	en: "Inbound method"
}, {
	id: 640,
	cn: "出库管理",
	tc: "出庫管理",
	en: "Outbound management"
}, {
	id: 641,
	cn: "质检信息",
	tc: "質檢資訊",
	en: "Quality inspection"
}, {
	id: 642,
	cn: "添加商品",
	tc: "添加商品",
	en: "Add product"
}, {
	id: 643,
	cn: "商品重量",
	tc: "商品重量",
	en: "Product weight"
}, {
	id: 644,
	cn: "商品品牌",
	tc: "商品品牌",
	en: "Product brand"
}, {
	id: 645,
	cn: "上架货位",
	tc: "上架貨位",
	en: "Shelf storage unit"
}, {
	id: 646,
	cn: "下架货位",
	tc: "下架貨位",
	en: "Shelf storage unit"
}, {
	id: 647,
	cn: "绑定到的唯一码",
	tc: "綁定到的唯一碼",
	en: "Bound to unique code"
}, {
	id: 648,
	cn: "添加权限",
	tc: "添加權限",
	en: "Add permission"
}, {
	id: 649,
	cn: "描述",
	tc: "描述",
	en: "Description"
}, {
	id: 650,
	cn: "请选择原仓库操作员",
	tc: "請選擇原倉庫操作員",
	en: "Please select the original warehouse operator"
}, {
	id: 651,
	cn: "请选择目标仓库操作员",
	tc: "請選擇目標倉庫操作員",
	en: "Please select the target warehouse operator"
}, {
	id: 652,
	cn: "生成入库单",
	tc: "生成入庫單",
	en: "Generate inbound order"
}, {
	id: 653,
	cn: "已生成",
	tc: "已生成",
	en: "Generated"
}, {
	id: 654,
	cn: "确认生成入库单？",
	tc: "確認生成入庫單？",
	en: "Confirm generating inbound order?"
}, {
	id: 655,
	cn: "权限名称不能为空",
	tc: "權限名稱不能為空",
	en: "Permission name cannot be empty"
}, {
	id: 656,
	cn: "请选择权限类型",
	tc: "請選擇權限類型",
	en: "Please select permission type"
}, {
	id: 657,
	cn: "员工总数",
	tc: "員工總數",
	en: "Total employees"
}, {
	id: 658,
	cn: "密码不能为空",
	tc: "密碼不能為空",
	en: "Password cannot be empty"
}, {
	id: 659,
	cn: "手机号不能为空",
	tc: "手機號碼不能為空",
	en: "Mobile number cannot be empty"
}, {
	id: 660,
	cn: "所属仓库不能为空",
	tc: "所屬倉庫不能為空",
	en: "Warehouse cannot be empty"
}, {
	id: 661,
	cn: "角色类型不能为空",
	tc: "角色類型不能為空",
	en: "Role type cannot be empty"
}, {
	id: 662,
	cn: "头像",
	tc: "頭像",
	en: "Avatar"
}, {
	id: 663,
	cn: "新密码",
	tc: "新密碼",
	en: "New password"
}, {
	id: 664,
	cn: "确认密码",
	tc: "確認密碼",
	en: "Confirm password"
}, {
	id: 665,
	cn: "请输入新密码",
	tc: "請輸入新密碼",
	en: "Please enter new password"
}, {
	id: 666,
	cn: "请输入确认密码",
	tc: "請輸入確認密碼",
	en: "Please enter confirm password"
}, {
	id: 667,
	cn: "确认密码不能为空",
	tc: "確認密碼不能為空",
	en: "Confirm password cannot be empty"
}, {
	id: 668,
	cn: "两次输入的密码不一致",
	tc: "兩次輸入的密碼不一致",
	en: "The two entered passwords are inconsistent"
}, {
	id: 669,
	cn: "重置密码成功",
	tc: "重置密碼成功",
	en: "Reset password successful"
}, {
	id: 670,
	cn: "先到期先出",
	tc: "先到期先出",
	en: "First expire first out"
}, {
	id: 671,
	cn: "全部",
	tc: "全部",
	en: "All"
}, {
	id: 672,
	cn: "待上架",
	tc: "待上架",
	en: "Pending on-shelf"
}, {
	id: 673,
	cn: "待指派",
	tc: "待指派",
	en: "Pending assignment"
}, {
	id: 674,
	cn: "待复核",
	tc: "待複核",
	en: "Pending review"
}, {
	id: 675,
	cn: "待出库验货",
	tc: "待出庫驗貨",
	en: "Pending outbound inspection"
}, {
	id: 676,
	cn: "待生成入库单",
	tc: "待生成入庫單",
	en: "Pending generating inbound order"
}, {
	id: 677,
	cn: "待入库验货",
	tc: "待入庫驗貨",
	en: "Pending inbound inspection"
}, {
	id: 678,
	cn: "待入库上架",
	tc: "待入庫上架",
	en: "Pending on-shelf"
}, {
	id: 679,
	cn: "总仓",
	tc: "總倉",
	en: "Administrator"
}, {
	id: 680,
	cn: "子仓",
	tc: "子倉",
	en: "Sub administrator"
}, {
	id: 681,
	cn: "请选择记录",
	tc: "請選擇記錄",
	en: "Please select record"
}, {
	id: 682,
	cn: "暗盘",
	tc: "暗盤",
	en: "Blind Count"
}, {
	id: 683,
	cn: "明盘",
	tc: "明盤",
	en: "Open Count"
}, {
	id: 684,
	cn: "入库",
	tc: "入庫",
	en: "Inbound"
}, {
	id: 685,
	cn: "出库",
	tc: "出庫",
	en: "Outbound"
}, {
	id: 686,
	cn: "请选择RFID标签",
	tc: "請選擇RFID標籤",
	en: "Please select RFID label"
}, {
	id: 687,
	cn: "编辑员工账号",
	tc: "編輯員工帳號",
	en: "Edit employee account"
}, {
	id: 688,
	cn: "请选择溯源码",
	tc: "請選擇溯源碼",
	en: "Please select trace code"
}, {
	id: 689,
	cn: "未使用",
	tc: "未使用",
	en: "Unused"
}, {
	id: 690,
	cn: "已使用",
	tc: "已使用",
	en: "Used"
}, {
	id: 691,
	cn: "请选择需要导出的项",
	tc: "請選擇需要導出的項",
	en: "Please select the items to be exported"
}, {
	id: 692,
	cn: "请输入仓库地址对应的邮编",
	tc: "請輸入倉庫地址對應的郵遞區號",
	en: "Please enter the zip code corresponding to the warehouse address"
}, {
	id: 693,
	cn: "用户名称",
	tc: "用戶名稱",
	en: "User name"
}, {
	id: 694,
	cn: "手机号码",
	tc: "手機號碼",
	en: "Mobile number"
}, {
	id: 695,
	cn: "电子邮箱",
	tc: "電子郵件",
	en: "Email"
}, {
	id: 696,
	cn: "创建日期",
	tc: "建立日期",
	en: "Creation date"
}, {
	id: 697,
	cn: "用户名称不能为空",
	tc: "用戶名稱不能為空",
	en: "User name cannot be empty"
}, {
	id: 698,
	cn: "请上传72*72px的图片",
	tc: "請上傳72*72px的圖片",
	en: "Please upload a 72*72px picture"
}, {
	id: 699,
	cn: "图片大小不得超过5MB",
	tc: "圖片大小不得超過5MB",
	en: "Picture size cannot exceed 5MB"
}, {
	id: 700,
	cn: "请上传公司LOGO",
	tc: "請上傳公司LOGO",
	en: "Please upload company logo"
}, {
	id: 701,
	cn: "时",
	tc: "時",
	en: "Hour"
}, {
	id: 702,
	cn: "天",
	tc: "天",
	en: "Day"
}, {
	id: 703,
	cn: "星期",
	tc: "星期",
	en: "Week"
}, {
	id: 704,
	cn: "月",
	tc: "月",
	en: "Month"
}, {
	id: 705,
	cn: "单量",
	tc: "單量",
	en: "Order quantity"
}, {
	id: 706,
	cn: "密码长度不能小于8",
	tc: "密碼長度不能少於8",
	en: "Password length cannot be less than 8"
}, {
	id: 707,
	cn: "须包含字母、数字、特殊字符中的二种或以上",
	tc: "須包含字母、數位、特殊字元中的二種或以上",
	en: "Must contain at least two types of letters, digits, and special characters"
}, {
	id: 708,
	cn: "批量导出唯一码",
	tc: "批量导出唯一碼",
	en: "Batch export of unique codes"
}, {
	id: 709,
	cn: "同步商品",
	tc: "同步商品",
	en: "Sync product"
}, {
	id: 710,
	cn: "同步",
	tc: "同步",
	en: "Sync"
}, {
	id: 711,
	cn: "同步中",
	tc: "同步中",
	en: "Syncing"
}, {
	id: 712,
	cn: "同步成功",
	tc: "同步成功",
	en: "Sync successful"
}, {
	id: 713,
	cn: "同步失败，请重新尝试",
	tc: "同步失敗，請重新嘗試",
	en: "Sync failed, please try again"
}, {
	id: 714,
	cn: "同步库存",
	tc: "同步庫存",
	en: "Sync inventory"
}, {
	id: 715,
	cn: "队列中，请稍后留意通知",
	tc: "隊列中，請稍後留意通知",
	en: "In the queue, please pay attention to the notification later"
}, {
	id: 716,
	cn: "立即下载",
	tc: "立即下載",
	en: "Download now"
}, {
	id: 717,
	cn: "库存信息",
	tc: "庫存資訊",
	en: "Inventory information"
}];

const ShowText = (params: any) => {
	let language: any = localStorage.getItem("language") || 'cn';
	if (!language) {
		language = 1;
	}
	let txt = "";
	if (typeof params == "number") {
		TextList.forEach((v: any) => {
			if (v.id == params) {
				txt = v[language];
			}
		});
	} else {
		txt = params;
		TextList.forEach((v: any) => {
			if (v.cn == params) {
				txt = v[language];
			}
		});
	}
	return txt;
};

export default {
	ShowText,
};